/**
 * Stytch's login box, themed with the console's tokens (styles.css `:root`, the «Sereno» theme
 * chosen in #301). Stytch renders in its own shadow DOM, outside our stylesheet's reach, so the
 * values are repeated here: keep both in sync (contrast.test.ts and tema.test.ts check them).
 */
const base = {
  'font-family': '"Lexend Variable", system-ui, -apple-system, "Segoe UI", Roboto, sans-serif',
  'font-family-mono': '"JetBrains Mono Variable", ui-monospace, Menlo, monospace',
  'header-font': '"Lexend Variable", system-ui, sans-serif',
  'text-base': '15px',
  'rounded-base': '4px',
  'button-radius': '10px',
  'input-radius': '10px',
  'container-radius': '16px',
  'container-width': '420px',
  'transition-duration': '120ms',
} as const;

export const stytchTheme = {
  light: {
    ...base,
    'color-scheme': 'light',
    background: '#fefdfb',
    foreground: '#22201c',
    primary: '#1f5f7d',
    'primary-foreground': '#ffffff',
    secondary: '#eeece7',
    'secondary-foreground': '#22201c',
    muted: '#eeece7',
    'muted-foreground': '#69635a',
    accent: '#e3eef3',
    'accent-foreground': '#1a5270',
    border: '#d9d5cc',
    input: '#857a6b',
    ring: '#2f7596',
    destructive: '#a82a1f',
    'destructive-foreground': '#ffffff',
    warning: '#8a5600',
    success: '#2b6d45',
    'container-border': '#d9d5cc',
    shadow: '0 8px 24px -14px rgba(58, 44, 24, 0.16)',
  },
  dark: {
    ...base,
    'color-scheme': 'dark',
    background: '#201e1a',
    foreground: '#ece7df',
    primary: '#5fa6c8',
    'primary-foreground': '#0a1d26',
    secondary: '#24221e',
    'secondary-foreground': '#ece7df',
    muted: '#24221e',
    'muted-foreground': '#a39b8e',
    accent: '#16303b',
    'accent-foreground': '#9fd0e6',
    border: '#36322c',
    input: '#8a8274',
    ring: '#5fa6c8',
    destructive: '#f08a7c',
    'destructive-foreground': '#1a0806',
    warning: '#e2ad55',
    success: '#6cc591',
    'container-border': '#36322c',
    shadow: 'none',
  },
} as const;
